module.exports = __webpack_public_path__ + "static/gv-logo-256ef817a1b05550f940040b3fae331f.png";